import { render, staticRenderFns } from "./SubtaskForm.vue?vue&type=template&id=fbb778f4&scoped=true&"
import script from "./SubtaskForm.vue?vue&type=script&lang=js&"
export * from "./SubtaskForm.vue?vue&type=script&lang=js&"
import style0 from "./SubtaskForm.vue?vue&type=style&index=0&id=fbb778f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb778f4",
  null
  
)

export default component.exports